import type { SubscriptionStatus } from '@/types';

export function isCurrentFreePlan(
  status: Pick<SubscriptionStatus, 'isFreeUser' | 'isPaidSubscriber'> | null | undefined,
  isAuthenticated: boolean,
): boolean {
  return isAuthenticated && !!status?.isFreeUser && !status.isPaidSubscriber;
}

export function isCasePassCheckoutAvailable(
  isAuthenticated: boolean,
): boolean {
  return isAuthenticated;
}

export function isCurrentPaidTier(
  status: Pick<SubscriptionStatus, 'isPaidSubscriber' | 'isTrial'> | null | undefined,
  currentTier: string | null | undefined,
  requestedTier: string,
): boolean {
  return !!status?.isPaidSubscriber && !status.isTrial && currentTier === requestedTier;
}

export function isCurrentPaidPlanId(
  status: (Pick<SubscriptionStatus, 'isPaidSubscriber' | 'isTrial'> & {
    subscription?: Pick<NonNullable<SubscriptionStatus['subscription']>, 'plan_id'> | null;
  }) | null | undefined,
  requestedPlanId: string | null | undefined,
): boolean {
  return !!status?.isPaidSubscriber && !status.isTrial && !!requestedPlanId && status.subscription?.plan_id === requestedPlanId;
}

export function isTrialUpgradeTier(
  status: Pick<SubscriptionStatus, 'isPaidSubscriber' | 'isTrial'> | null | undefined,
  currentTier: string | null | undefined,
  requestedTier: string,
): boolean {
  return !!status?.isTrial && !status.isPaidSubscriber && currentTier === requestedTier;
}
